import { defineStore } from 'pinia';
import { funilPost } from '../helper/funilApi';

export const usePipelineStore = defineStore('pipeline', {
  state: () => ({ pipeline: null, stages: [], leads: [], pipelines: [], currentPipelineId: null, loading: false, error: null, _account: null }),
  getters: {
    leadsByStage: (s) => (stageId) => s.leads.filter((l) => l.stage_id === stageId),
    stageTotal: (s) => (stageId) => s.leads.filter((l) => l.stage_id === stageId).reduce((a, l) => a + Number(l.valor || 0), 0),
  },
  actions: {
    async loadBoard(accountId, pipelineId) {
      this.loading = true; this.error = null; this._account = accountId;
      try {
        const b = await funilPost('funil-board', { chatwoot_account_id: accountId, pipeline_id: pipelineId || '' });
        this.pipeline = b && b.pipeline; this.stages = (b && b.stages) || []; this.leads = (b && b.leads) || [];
        this.currentPipelineId = this.pipeline && this.pipeline.id;
      } catch (e) { this.error = String(e && e.message || e); } finally { this.loading = false; }
    },
    async loadPipelines(accountId) { this.pipelines = (await funilPost('funil-pipelines', { chatwoot_account_id: accountId })) || []; return this.pipelines; },
    async createPipeline(accountId, nome) { const r = await funilPost('funil-pipeline-create', { chatwoot_account_id: accountId, nome }); await this.loadPipelines(accountId); return r; },
    async scoreLead(leadId) { return await funilPost('funil-lead-score', { lead_id: leadId }); },
    async moveLead(leadId, stageId, motivo) {
      const lead = this.leads.find((l) => l.id === leadId);
      const prev = lead ? lead.stage_id : null;
      if (lead) lead.stage_id = stageId;
      try { await funilPost('funil-lead-move', { lead_id: leadId, stage_id: stageId, ator: 'dono', motivo: motivo || '' }); }
      catch (e) { if (lead) lead.stage_id = prev; this.error = String(e && e.message || e); }
    },
    async loadTasks(leadId) { return await funilPost('funil-tasks-list', { lead_id: leadId }); },
    async upsertTask(leadId, titulo, vence_em) { return await funilPost('funil-task-upsert', { lead_id: leadId, titulo, vence_em }); },
    async toggleTask(id, feito) { return await funilPost('funil-task-toggle', { id, feito }); },
    async loadEvents(leadId) { return await funilPost('funil-lead-events', { lead_id: leadId }); },
    async loadReport() { return await funilPost('funil-report', { chatwoot_account_id: this._account }); },
    async upsertLead(payload) {
      const business_id = this.pipeline && this.pipeline.business_id;
      const pipeline_id = this.pipeline && this.pipeline.id;
      const r = await funilPost('funil-lead-upsert', Object.assign({ business_id, pipeline_id, ator: 'dono' }, payload));
      await this.loadBoard(this._account);
      return r;
    },
    async saveStages(stages) {
      await funilPost('funil-stages', { pipeline_id: this.pipeline && this.pipeline.id, stages });
      await this.loadBoard(this._account);
    },
  },
});
